import { ObjectRepository } from '@framework/repository';
import type { ElementDescriptionJSON, ElementId, ModelId, ViewModelId, DBPath } from 'balus-common';
import { RTDBPath } from 'balus-common';
import { ElementDescription } from './ElementDescription';
import type { ElementDescriptionTarget } from './ElementDescriptionTarget';

export class ElementDescriptionRepository extends ObjectRepository<ElementDescriptionJSON, ElementDescription> {
  static buildFromIds(
    viewModelId: ViewModelId,
    modelId: ModelId,
    target: ElementDescriptionTarget,
    elementId: ElementId
  ): ElementDescriptionRepository {
    return new this(ElementDescription, this.getDBPath(viewModelId, modelId, target, elementId));
  }

  private static getDBPath(
    viewModelId: ViewModelId,
    modelId: ModelId,
    target: ElementDescriptionTarget,
    elementId: ElementId
  ): DBPath {
    switch (target) {
      case 'Node':
        return RTDBPath.Node.descriptionPath(viewModelId, modelId, elementId);
      case 'Zone':
        return RTDBPath.Zone.descriptionPath(viewModelId, modelId, elementId);
      default:
        throw new Error(`Invalid target: ${target}`);
    }
  }
}
